/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAdminBenutzerDetailDto } from '../../models/lexplus-admin-benutzer-detail-dto';
import { LexplusUpdateAdminBenutzerDto } from '../../models/lexplus-update-admin-benutzer-dto';

export interface AdminBenutzerverwaltungControllerUpdateV1$Params {
  id: string;
      body: LexplusUpdateAdminBenutzerDto
}

export function adminBenutzerverwaltungControllerUpdateV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAdminBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAdminBenutzerDetailDto>;
    })
  );
}

adminBenutzerverwaltungControllerUpdateV1.PATH = '/v1/benutzerverwaltung/{id}';
